import Select, { SelectOption } from '@amzn/meridian/select';
import React from 'react';
import { useIntl } from 'react-intl';
import { FILTER_DROPDOWN_WIDTH } from '../../../Util/GlobalConstants';
import { DEFAULT_ALL, FilterIdentity, FilterProps } from './Type/FilterType';
import {
  D2_VERTICALS,
  TOTAL_VERTICALS,
  convertToVerticalOption,
} from '../../../Util/Vertical';

const BasicFilter: React.FC<FilterProps> = ({
  label,
  value,
  filterOptions,
  setValue,
  identity,
  page,
  ccxDetailsPage,
}: FilterProps): React.ReactElement => {
  const intl = useIntl();

  const clickstreamDataAttributesGenerator = (
    value: string,
    identity: string,
    page: string,
    isDefault: boolean,
    ccxDetailsPage?: string
  ) => {
    return {
      'data-csa-c-type': 'select',
      'data-csa-c-slot-id': `lighthouse-filters-select-field-${identity}-slot`,
      'data-csa-c-content-id': `lighthouse-filters-select-field-${identity}`,
      'data-csa-c-selected-value': isDefault ? DEFAULT_ALL : value,
      'data-csa-c-tag1': page,
      ...(ccxDetailsPage && { 'data-csa-c-tag2': ccxDetailsPage }),
    };
  };

  const verticalOptionsGenerator = (
    option: string,
    identity: string,
    page: string,
    ccxDetailsPage?: string
  ) => {
    return TOTAL_VERTICALS.has(convertToVerticalOption(option)) ? (
      <SelectOption
        label={intl.formatMessage({
          id: 'cs_perfportal_aggregated_metrics',
          defaultMessage: 'Aggregated',
        })}
        value={option}
        key={`${identity}-option`}
        {...clickstreamDataAttributesGenerator(
          option,
          identity,
          page,
          false,
          ccxDetailsPage
        )}
      />
    ) : (
      <SelectOption
        label={
          D2_VERTICALS.has(convertToVerticalOption(option)) ? 'D2AS' : option
        }
        value={option}
        key={`${identity}-option`}
        {...clickstreamDataAttributesGenerator(
          option,
          identity,
          page,
          false,
          ccxDetailsPage
        )}
      />
    );
  };

  return identity === FilterIdentity.VERTICAL ? (
    <Select
      label={label}
      value={value}
      onChange={setValue}
      size='xlarge'
      width={FILTER_DROPDOWN_WIDTH}
      key={identity}
      data-cy={identity}
    >
      {filterOptions.map(option => {
        return verticalOptionsGenerator(option, identity, page, ccxDetailsPage);
      })}
    </Select>
  ) : (
    <Select
      label={label}
      value={value}
      onChange={setValue}
      size='xlarge'
      width={FILTER_DROPDOWN_WIDTH}
      data-cy={identity}
      key={identity}
    >
      <SelectOption
        label={intl.formatMessage({
          id: 'cs_perfportal_all',
          defaultMessage: 'All',
        })}
        value={DEFAULT_ALL}
        key={`${identity}-${DEFAULT_ALL}`}
        {...clickstreamDataAttributesGenerator(
          value,
          identity,
          page,
          true,
          ccxDetailsPage
        )}
      />

      {filterOptions.map(option => (
        <SelectOption
          label={option}
          value={option}
          key={`${identity}-${option}`}
          {...clickstreamDataAttributesGenerator(
            value,
            identity,
            page,
            false,
            ccxDetailsPage
          )}
        />
      ))}
    </Select>
  );
};

export default BasicFilter;
